import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class';
import { eventBus } from '../../../main';
import { ProfileService } from '../../../services';
import { PROFILE_MODULE_NAMESPACE, PROFILE_SET_TICKET_SUBSTATUS } from '../../../store/profile/profile-types.store';

const ProfileStore = namespace(PROFILE_MODULE_NAMESPACE)

@Component({})
export default class TicketSubstatus extends Vue {

  @ProfileStore.Mutation(PROFILE_SET_TICKET_SUBSTATUS)
  storeSetTicketSubstatus: (payload: {id?:number, name?:string, disabled?:boolean}) => void;

  @Watch('disabled')
  handleDisabled(val)
  {
    //if(val)
    this.params.disabled = val
    this.loadTicketSubstatus()
  }

  ticketSubstatus:any[]
  headers:any[]
  profileService:ProfileService
  dialogDelete:boolean
  idToDelete:number | null
  loading:boolean
  disabled:boolean
  params:any

  constructor () {
    super()
    this.profileService = new ProfileService()
    this.ticketSubstatus = []
    this.headers=[
      { text: 'Nom', value: 'name', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Actions', value: 'name', sortable: false, class: 'text-xs-right primaryDark--text body-2 font-weight-bold' }
    ],
    this.dialogDelete = false
    this.idToDelete = null
    this.loading = false
    this.disabled = false
    this.params = {}
  }

  mounted()
  {
    eventBus.$on('TICKET_SUBSTATUS_REALOAD',()=>{
      this.ticketSubstatus = []
      this.loadTicketSubstatus()
    })
    this.loadTicketSubstatus()
  }

  beforeDestroy()
  {
    eventBus.$off('TICKET_SUBSTATUS_REALOAD')
  }

  loadTicketSubstatus()
  {
    this.loading = true
    this.profileService.getTicketSubstatus(this.params).then(result=>{
      this.ticketSubstatus = result
      this.loading = false
    }).catch(error=>{
      console.log('loadTicketSubstatus : ',error)
      this.loading = false
    })
  }

  edit(item:any)
  {
    this.storeSetTicketSubstatus({
      id:item.id,
      name:item.name,
      disabled:item.disabled
    })
    eventBus.$emit('EDIT_TICKET_SUBSTATUS', item)
  }

  deleteItem()
  {
    console.log('delete item : ', this.idToDelete)
    this.profileService.deleteTicketSubstatu(this.idToDelete).then((reponse)=>{
      this.idToDelete = null
      this.dialogDelete = false
      this.loadTicketSubstatus()
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/profile/ticket-substatus/index.ts